var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecapSinistre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.962,
    height: 36.493,
    viewBox: "0 0 29.962 36.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recap-sinistre",
    transform: "translate(0.75 1.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1302",
    "data-name": "Groupe 1302",
    transform: "translate(8.305 -1.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    d: "M.933,0H2.576A.933.933,0,0,1,3.51.933v23.6a.01.01,0,0,1-.01.01H.01a.01.01,0,0,1-.01-.01V.933A.933.933,0,0,1,.933,0Z",
    transform: "matrix(0.804, 0.595, -0.595, 0.804, 17.038, 1.607)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_219",
    "data-name": "Ligne 219",
    y1: 6.226,
    x2: 2.429,
    transform: "translate(0 21.327)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_220",
    "data-name": "Ligne 220",
    x1: 5.249,
    y2: 4.137,
    transform: "translate(0 23.416)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1303",
    "data-name": "Groupe 1303",
    transform: "translate(0 3.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1267",
    "data-name": "Trac\\xE9 1267",
    d: "M831.02,350.437v19.4",
    transform: "translate(-808.123 -344.344)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1268",
    "data-name": "Trac\\xE9 1268",
    d: "M841.738,372.79l-8.157,6H820.468a1.63,1.63,0,0,1-1.628-1.63V348.839a1.633,1.633,0,0,1,1.628-1.643h19.627a1.626,1.626,0,0,1,1.3.647v.013",
    transform: "translate(-818.84 -347.196)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1269",
    "data-name": "Trac\\xE9 1269",
    d: "M834.882,360.725h-8.259v6.157",
    transform: "translate(-811.992 -335.291)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapSinistre);
export default __webpack_public_path__ + "static/media/recap-sinistre.5701444f9b66b37a4c9ad8453e94ef1c.svg";
export { ForwardRef as ReactComponent };